import { Alert } from 'avo-ui'
import { ExportPointMember } from 'components/loyalty-program/export-point-member/ExportPointMember'
import { INITIAL_DATA_FILTER } from 'configs/loyalty-program/configTableExportPointMember'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'
import { API_EXPORT_POINT_MEMBER } from 'services/apiExportPointMember'
import { useFetch } from 'services/useFetch'
import { downloadFile, getAllQueryParams, setQueryParams } from 'utils/utils'

export const ExportPointMemberContainer = () => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_FILTER
    const { fetching: getHistoryExport, data: historyExport, isLoading } = useFetch(API_EXPORT_POINT_MEMBER.LIST)
    const { fetching: exportPointMember, isExporting } = useFetch(API_EXPORT_POINT_MEMBER.EXPORT)
    const [modal, setModal] = useState({
        export: false,
    })
    const [exportDate, setExportDate] = useState({
        start_date: '',
        end_date: '',
    })

    useEffect(() => {
        const currentQuery = { ...query }
        Object.entries(currentQuery).forEach(([key, item]) => {
            if (key === 'types') {
                const valueOfQuery = item?.split(',')
                currentQuery[key] = valueOfQuery
            }
        })
        fetchHistoryExportList(currentQuery)
    }, [location?.search])

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const fetchHistoryExportList = (item = { ...query }) => {
        getHistoryExport(item)
    }

    const setShowModal = (item) => {
        setModal({ ...modal, ...item })
    }

    const setShowAlert = (message, itemModal) => {
        setShowModal(itemModal)
        return Alert({
            icon: 'success',
            title: 'Success',
            message,
        })
    }

    const onChangeDate = ({ name, value }) => {
        setExportDate({ ...exportDate, [name]: value })
    }

    const onExport = () => {
        const startDate = exportDate.start_date || exportDate.end_date
        const endDate = exportDate.end_date || exportDate.start_date

        const finalExportDate = {
            start_date: startDate,
            end_date: endDate,
        }

        exportPointMember(finalExportDate, '', {}, 'blob').then((response) => {
            const formattedStart = moment(finalExportDate.start_date).format('DD-MM-YYYY')
            const formattedEnd = moment(finalExportDate.end_date).format('DD-MM-YYYY')

            const fileName =
                formattedStart === formattedEnd
                    ? `Point Member ${formattedStart}.csv`
                    : `Point Member ${formattedStart} s/d ${formattedEnd}.csv`

            downloadFile(null, response, fileName)
            setExportDate({
                start_date: '',
                end_date: '',
            })
            setShowAlert('Point Member Exported', { export: false })
            if (query?.search) {
                onChangeQuery({ ...query, search: '' })
            } else {
                fetchHistoryExportList({ ...query })
            }
        })
    }

    const props = {
        dataList: historyExport?.data,
        modal,
        setShowModal,
        query,
        onChangeQuery,
        onChangeDate,
        onExport,
        exportDate,
        isLoading,
        isExporting,
    }

    return <ExportPointMember {...props} />
}
